import axios from "axios";
import Tag from "../Models/Tag";

export default class ArticleRepository {

    search(count: number, filters: Tag[], page: number, onSuccess: (data: any) => void, hideSearchField: string) {
        axios.post("/api/ContentDataApi/SearchArticles", { fetchCount: count, page: page, Tags: filters, searchType: hideSearchField }).then((response) => {
            if (response && response.data) {
                onSuccess(response.data.data);
            } else {
                console.error("Unable to get data for content archive");
                return "";
            }
        });
    }
}